var map = {
	"./AmericanFootball.svg": 63327,
	"./AussieRules.svg": 43761,
	"./Badminton.svg": 86324,
	"./Boxing.svg": 6579,
	"./Callofduty.svg": 33689,
	"./CounterStrike.svg": 11976,
	"./DOTA.svg": 1880,
	"./Esports.svg": 74774,
	"./Futsal.svg": 29109,
	"./Handball.svg": 30374,
	"./Heartstone.svg": 82889,
	"./LeagueOfLegends.svg": 45604,
	"./NBAK.svg": 56994,
	"./Overwatch.svg": 24057,
	"./RainBowsix.svg": 93700,
	"./RocketLeague.svg": 78689,
	"./Snooker.svg": 23255,
	"./StarCraft.svg": 3255,
	"./Stats-new.svg": 70081,
	"./TableTennis.svg": 10283,
	"./account.svg": 35943,
	"./arrow-double-wide.svg": 66607,
	"./arrow-double.svg": 86825,
	"./arrowleft.svg": 43138,
	"./arrowright-new.svg": 69100,
	"./back-arc.svg": 65916,
	"./back.svg": 24923,
	"./bang-orange.svg": 74199,
	"./bang.svg": 40544,
	"./bank-status.svg": 19831,
	"./bank-transfer.svg": 25120,
	"./banker.svg": 58897,
	"./baseball.svg": 6558,
	"./basketball.svg": 96471,
	"./best-odds.svg": 64243,
	"./booking-code.svg": 35227,
	"./bottom-bar.svg": 78635,
	"./broadcast.svg": 34079,
	"./calendar.svg": 82340,
	"./calender-new.svg": 14253,
	"./callus.svg": 77194,
	"./card.svg": 93272,
	"./check-select.svg": 847,
	"./check-trade.svg": 61019,
	"./checked-select.svg": 61598,
	"./checked.svg": 92145,
	"./clear.svg": 42217,
	"./close-round.svg": 68565,
	"./close.svg": 5050,
	"./collapse.svg": 7583,
	"./contact-us.svg": 66195,
	"./cricket.svg": 29839,
	"./darts.svg": 17908,
	"./delete-jianhao.svg": 12342,
	"./delete-new.svg": 6282,
	"./delete-no-jianhao.svg": 50787,
	"./description.svg": 38228,
	"./done.svg": 76966,
	"./download.svg": 60846,
	"./e-basketball.svg": 51966,
	"./e-iceHockey.svg": 68714,
	"./e-soccer.svg": 92045,
	"./edit-account.svg": 11208,
	"./edit-new.svg": 97599,
	"./edit.svg": 68074,
	"./email.svg": 25834,
	"./expand-double.svg": 3580,
	"./favorite.svg": 14138,
	"./games.svg": 55443,
	"./gantanhao.svg": 37107,
	"./help-gray.svg": 3733,
	"./help.svg": 71807,
	"./iceHockey.svg": 5628,
	"./indicator.svg": 27269,
	"./jiangbei.svg": 31217,
	"./live.svg": 20072,
	"./load_code.svg": 28682,
	"./market.svg": 33830,
	"./match-tracker.svg": 62094,
	"./menu-favor.svg": 47380,
	"./menu.svg": 56479,
	"./message.svg": 11235,
	"./more.svg": 80361,
	"./my_matches.svg": 75854,
	"./odds-less2.svg": 9436,
	"./ongoing.svg": 95373,
	"./picture.svg": 5992,
	"./png-x.svg": 3096,
	"./queren.svg": 45748,
	"./refresh-ring.svg": 79378,
	"./refresh.svg": 34323,
	"./rili.svg": 82676,
	"./rugby.svg": 59711,
	"./safe.svg": 90157,
	"./search-new.svg": 20139,
	"./search.svg": 47238,
	"./service.svg": 72451,
	"./setting.svg": 64682,
	"./share-code.svg": 34739,
	"./shoucang.svg": 4042,
	"./signal.svg": 29358,
	"./single-check.svg": 48165,
	"./soccer.svg": 33951,
	"./sort.svg": 91870,
	"./spin-auto.svg": 27570,
	"./spin-rebet.svg": 91445,
	"./spin-share.svg": 44312,
	"./sport.svg": 13116,
	"./square-share.svg": 92765,
	"./standard.svg": 22161,
	"./stats.svg": 34123,
	"./success.svg": 65055,
	"./support.svg": 47643,
	"./tennis.svg": 18599,
	"./tips.svg": 80960,
	"./toTop.svg": 94322,
	"./today-match.svg": 46633,
	"./today.svg": 83665,
	"./toggle.svg": 29936,
	"./tomorrow.svg": 20051,
	"./tracker.svg": 41798,
	"./trangle-round.svg": 53622,
	"./trangle.svg": 4321,
	"./transactions.svg": 99845,
	"./trash.svg": 88392,
	"./trophy.svg": 73612,
	"./up.svg": 56813,
	"./video.svg": 52611,
	"./virtual.svg": 9875,
	"./voice-up.svg": 82314,
	"./volleyball.svg": 32230,
	"./vsoccer.svg": 1745,
	"./warn-gantanhao.svg": 95440,
	"./yishoucang.svg": 69016
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21231;